import {makeStyles} from "@fluentui/react-components";
import {pinkTheme} from "./theme";

export const useCommonPageStyles = makeStyles({
    nbt_root:{
        height:'100vh',
        display:'flex',
        flexDirection:'column',
        gap:'1rem',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor:pinkTheme.bgColor100
    },
    textStyle: {
        fontWeight:'bold',
        fontSize:'large',
        textAlign:'center'
    }
})